// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IInvoiceSummaryRecordDto
 */
export interface IInvoiceSummaryRecordDto {
    /**
     * 
     * @type {Date}
     * @memberof IInvoiceSummaryRecordDto
     */
    invoice_close_date?: Date;
    /**
     * 
     * @type {number}
     * @memberof IInvoiceSummaryRecordDto
     */
    invoice_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IInvoiceSummaryRecordDto
     */
    invoice_amount?: number;
}

/**
 * Check if a given object implements the IInvoiceSummaryRecordDto interface.
 */
export function instanceOfIInvoiceSummaryRecordDto(value: object): value is IInvoiceSummaryRecordDto {
    return true;
}

export function IInvoiceSummaryRecordDtoFromJSON(json: any): IInvoiceSummaryRecordDto {
    return IInvoiceSummaryRecordDtoFromJSONTyped(json, false);
}

export function IInvoiceSummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IInvoiceSummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'invoice_close_date': json['invoice_close_date'] == null ? undefined : (new Date(json['invoice_close_date'])),
        'invoice_id': json['invoice_id'] == null ? undefined : json['invoice_id'],
        'invoice_amount': json['invoice_amount'] == null ? undefined : json['invoice_amount'],
    };
}

export function IInvoiceSummaryRecordDtoToJSON(json: any): IInvoiceSummaryRecordDto {
    return IInvoiceSummaryRecordDtoToJSONTyped(json, false);
}

export function IInvoiceSummaryRecordDtoToJSONTyped(value?: IInvoiceSummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'invoice_close_date': value['invoice_close_date'] == null ? undefined : ((value['invoice_close_date']).toISOString().substring(0,10)),
        'invoice_id': value['invoice_id'],
        'invoice_amount': value['invoice_amount'],
    };
}

